/* tslint:disable */
/* eslint-disable */
/**
 * Import Api
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';

/**
 * 
 * @export
 * @interface SubjectDTO
 */
export interface SubjectDTO  {
    /**
     * 
     * @type {number}
     * @memberof SubjectDTO
     */
    id?: number;
    /**
     * 
     * @type {string}
     * @memberof SubjectDTO
     */
    subjectId?: string;
    /**
     * 
     * @type {string}
     * @memberof SubjectDTO
     */
    type?: string;
}

/**
 * Check if a given object implements the SubjectDTO interface.
 */
export function instanceOfSubjectDTO(value: object): value is SubjectDTO {
    return true;
}

export function SubjectDTOFromJSON(json: any): SubjectDTO {
    return SubjectDTOFromJSONTyped(json, false);
}

export function SubjectDTOFromJSONTyped(json: any, ignoreDiscriminator: boolean): SubjectDTO {
    if (json == null) {
        return json;
    }
    return {
        
                  'id': json['id'] == null ? undefined : json['id'],
                  'subjectId': json['subjectId'] == null ? undefined : json['subjectId'],
                  'type': json['type'] == null ? undefined : json['type'],
    };
}

export function SubjectDTOToJSON(json: any): SubjectDTO {
    return SubjectDTOToJSONTyped(json, false);
}

export function SubjectDTOToJSONTyped(value?: SubjectDTO | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }
    return {
        
        'id': value['id'],
        'subjectId': value['subjectId'],
        'type': value['type'],
    };
}


